export enum ApiErrorType {
  Error_Unknown = 'Error_Unknown',
  Error_Unauthorized = 'Error_Unauthorized'
}

export interface ApiErrorResponse {
  name: ApiErrorType;
  value: string;
  resourceNotFound: boolean;
  searchedLocation: string;
}